import notFound from '@/views/pages/404.vue'

const router = {
    path: '/404',
    name: '404',
    component: notFound,
    meta: {
        title: 'Page not found'
    }
  };

export default router
